import { SHA3 } from 'sha3';
import Exception from './exception.js';

const shared = {};

shared.assert = (cond) => {
    if (!cond) {
        throw new Error("Assert failed!");
    }
};

shared.secureHash = (str) => {
    const hash = new SHA3(512);
    hash.update(str);
    return hash.digest('hex');
}

shared.validateString = (str, max_length, strict_content_check = true) => {
    if (!str || str.length < 3) {
        throw new Exception("Invalid input.", { name: "Too short (3 min)" });
    }

    if (str.length > max_length) {
        throw new Exception("Invalid input.", { name: "Too long (18 max)" });
    }

    if (strict_content_check) {
        if (/[^ \p{L}\p{N}]/u.test(str)) {
            throw new Exception("Invalid input.", { name: "Only letters, digits, and spaces allowed." });
        }

        if (/ {2,}/.test(str)) {
            throw new Exception("Invalid input.", { name: "No double spaces allowed." });
        }
    }

    if (/^\s|\s$/.test(str)) {
        throw new Exception("Invalid input.", { name: "No leading or trailing spaces." });
    }
}

shared.validatePlayerName = (player_name) => {
    shared.validateString(player_name, 32);

    const lastChar = player_name[player_name.length - 1];
    if (!/\p{L}|\p{N}/u.test(lastChar)) {
        throw new Exception("Invalid input.", { name: "Must end with a letter or digit." });
    }

    const firstChar = player_name[0];
    if (!/\p{L}/u.test(firstChar)) {
        throw new Exception("Invalid input.", { name: "Must start with a letter." });
    }
}

shared.validatePassword = (password) => {
    if (!password || password.length < 5) {
        throw new Exception("Invalid input.", { password: "Too short (5 min)" });
    }
}

shared.validateMail = (mail) => {
    if (mail.length > 128) {
        throw new Exception("Invalid input.", { mail: "Too long (128 max)" });
    } else if (!/\S+@\S+\.\S+/.test(mail)) {
        throw new Exception("Invalid input.", { mail: "Invalid format" });
    }
}

shared.validateFaction = (faction) => {
    if (faction.length > 40) {
        throw new Exception("Invalid input.", { faction: "Too long (40 max)" });
    }
}

shared.validateFactionDescription = (faction_description) => {
    if (faction_description.length > 100000) {
        throw new Exception("Invalid input.", { faction_description: "Too long, sorry (100000 max)" });
    }
}

shared.validateFactionAndFactionDescription = (faction, faction_description) => {
    shared.validateFaction(faction);
    shared.validateFactionDescription(faction_description);
}

shared.validateSignUpInfo = (player_name, password, mail, faction, faction_description) => {
    shared.validatePlayerName(player_name)
    shared.validatePassword(password)
    shared.validateMail(mail)
    shared.validateFaction(faction)
    shared.validateFactionDescription(faction_description)
}

shared.validateFleetName = (fleet_name) => {
    shared.validateString(fleet_name, 32, false);
}

shared.validatePlanetName = (planet_name) => {
    shared.validateString(planet_name, 32, false);
}

shared.validateShipName = (ship_name) => {
    shared.validateString(ship_name, 32, false);
}

shared.validateChatSubject = (subject) => {
    shared.validateString(subject, 256, false);
}

shared.validateChatMessage = (content) => {
    shared.validateString(content, 131072, false);
}

shared.getSignUpErrors = (player_name, password, mail, faction, faction_description) => {
    let error = {};
    const catch_error = (foo) => {
        try {
            foo();
        } catch (e) {
            Object.assign(error, e.details);
        }
    }

    catch_error(() => {
        shared.validatePlayerName(player_name)
    });
    catch_error(() => {
        shared.validatePassword(password)
    });
    catch_error(() => {
        shared.validateMail(mail)
    });
    catch_error(() => {
        shared.validateFaction(faction)
    });
    catch_error(() => {
        shared.validateFactionDescription(faction_description)
    });
    return error;
}


export default shared;